import { render } from "./CustomSlider.vue?vue&type=template&id=b80bd776&scoped=true"
import script from "./CustomSlider.vue?vue&type=script&lang=js"
export * from "./CustomSlider.vue?vue&type=script&lang=js"

import "./CustomSlider.vue?vue&type=style&index=0&id=b80bd776&lang=scss&scoped=true"

import exportComponent from "/var/www/ddup_czb/slczb_app_web/view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b80bd776"]])

export default __exports__